module.exports = __webpack_public_path__ + "static/media/FavoriteOrange.9390289f.svg";